import { useDispatch, useSelector } from "react-redux";
import {
  setAreCompanyQuestionsShown,
  setCompanyQuestions,
  setCurrentLevel,
  setLevel,
} from "../../../redux/globalFunctions";
import translations from "../../../en.json";
import translationsNo from "../../../no.json";

export function PrevBtn() {
  const { currentLevel, companyQuestions, level, language } = useSelector(
    (state) => state.global
  );
  const dispatch = useDispatch();

  function handleClick() {
    if (currentLevel === 0 && companyQuestions === true) {
      dispatch(setCurrentLevel(currentLevel - 1));
      dispatch(setAreCompanyQuestionsShown(false));
    } else if (
      currentLevel === 1 &&
      companyQuestions === false &&
      level === 0
    ) {
      dispatch(setCurrentLevel(currentLevel - 2));
    } else if (currentLevel === 1 && level > 0) {
      dispatch(setLevel(level - 1));
    } else if (currentLevel === -1 && companyQuestions === true) {
      dispatch(setCurrentLevel(currentLevel - 1));
      dispatch(setCompanyQuestions(null));
    } else {
      dispatch(setCurrentLevel(currentLevel - 1));
    }
  }

  const btnText =
    language === "en"
      ? translations.navigateButtons
      : translationsNo.navigateButtons;

  return (
    <button
      onClick={handleClick}
      id="prevButton"
      disabled={currentLevel === -1} // this should be -2
    >
      {btnText.prev}
    </button>
  );
}
